import { html, nothing, unsafeCSS, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { when } from "@/common/directives/when";
import EkoElement from "@/utilities/element";
import style from "./primary-nav-item.css?inline";

@customElement("eko-primary-nav-item")
class PrimaryNavItem extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) active = false;
  @property({ reflect: true, type: Boolean }) disabled = false;
  @property({ reflect: true, type: String }) href?: string;
  @property({ reflect: true }) icon?: string;

  private renderButton(content: TemplateResult) {
    return html`
      <button class="eko-primary-nav-item__inner" ?disabled=${this.disabled} type="button">
        ${content}
      </button>
    `;
  }

  private renderChevron() {
    return html`<span class="eko-primary-nav-item__chevron">
      <eko-icon name="chevron-right" size="sm"></eko-icon>
    </span>`;
  }

  private renderIcon() {
    return this.icon
      ? html`<span class="eko-primary-nav-item__icon"
          ><eko-icon name=${this.icon} size="lg"></eko-icon
        ></span>`
      : nothing;
  }

  private renderLink(content: TemplateResult) {
    return html` <a
      class="eko-primary-nav-item__inner"
      href=${when(this.disabled, nothing, this.href)}>
      ${content}
    </a>`;
  }

  render() {
    const content = html`${this.renderIcon()}
      <span class="eko-primary-nav-item__label">
        <slot></slot>
      </span>
      ${this.renderChevron()}`;

    return html`<li class="eko-primary-nav-item">
      ${this.href ? this.renderLink(content) : this.renderButton(content)}
    </li>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-primary-nav-item": PrimaryNavItem;
  }
}

export default PrimaryNavItem;
